<template>
  <div class="ruleContent" v-html="ruleContent"></div>
</template>

<script>
export default {
  props: {
    ruleContent: String
  }
};
</script>

<style lang="less">
.ruleContent {
  box-sizing: border-box;
  width: 750px;
  padding: 30px 32px 80px;

  pre {
    white-space: pre-wrap;
  }

  font[size='1'] {
    font-size: 24px;
  }
  font[size='2'] {
    font-size: 26px;
  }
  font[size='3'] {
    font-size: 32px;
  }
  font[size='4'] {
    font-size: 36px;
  }
  font[size='5'] {
    font-size: 48px;
  }
  font[size='6'] {
    font-size: 64px;
  }
  font[size='7'] {
    font-size: 96px;
  }
}
</style>
